var _a;
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { generateHooks } from "../generators/generator.hooks";
import { removeBankAccountStart } from "./bankAccount.actions";
import { GENERATOR_PARAMS } from "./bankAccount.constants";
import { isRemovingBankAccountSelector, removeBankAccountError, } from "./bankAccount.selectors";
export var useDetail = (_a = generateHooks(GENERATOR_PARAMS), _a.useDetail), useCount = _a.useCount;
export var useRemoveBankAccount = function () {
    var dispatch = useDispatch();
    var _a = React.useState(), bankAccountId = _a[0], setBankAccountId = _a[1];
    var isRemoving = useSelector(function (state) {
        return isRemovingBankAccountSelector(state, bankAccountId);
    });
    var error = useSelector(function (state) {
        return removeBankAccountError(state, bankAccountId);
    });
    var removeAccount = function (_a) {
        var id = _a.id, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
        setBankAccountId(id);
        dispatch(removeBankAccountStart.getAction({ id: id, onSuccess: onSuccess, onFailure: onFailure }));
    };
    return {
        isRemoving: isRemoving,
        error: error,
        removeAccount: removeAccount,
    };
};
